<template>
  <div class="allience">
    <div class="choose-state">
      <span
        v-for="(choose,index) in chooses"
        :key="choose.name"
        @click="active(index,choose.name)"
        :class="isClass==index?'choose':''"
      >{{choose.name}}</span>
    </div>
    <div class="banner">
      <img :src="banners[isClass].imgUrl" alt />
    </div>
    <!-- 优惠服务 -->
    <div class="preferentital-service" v-if="isClass==0">
      <div class="preferentital-service-template" v-for="(msg,index) in msgs" :key="index" >
        <!-- <p v-text="(index+1+'.') + msg.headline"></p>
        <p>{{msg.createtime | times}}</p> -->
        <p v-html="msg.memo"></p>
        
      </div>
    </div>
    <!-- 学习教育 -->
    <div class="learn-to-teach" v-if="isClass==1">
      <div class="preferentital-service-template" v-for="(msg,index) in msgs" :key="index" >
        <!-- <p v-text="(index+1+'.') + msg.headline"></p>
        <p>{{msg.createtime | times}}</p> -->
        <p v-html="msg.memo"></p>
      </div>
    </div>
    <!-- 便捷咨询 -->
    <div class="convenient-consulting" v-if="isClass==2">
      <div class="preferentital-service-template" v-for="(msg,index) in msgs" :key="index" >
        <!-- <p v-text="(index+1+'.') + msg.headline"></p>
        <p>{{msg.createtime | times}}</p> -->
        <p v-html="msg.memo"></p>
      </div>
    </div>
    <!-- 其他服务 -->
    <div class="other-serve" v-if="isClass==3">
      <div class="preferentital-service-template" v-for="(msg,index) in msgs" :key="index" >
        <!-- <p v-text="(index+1+'.') + msg.headline"></p>
        <p>{{msg.createtime | times}}</p> -->
        <p v-html="msg.memo"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooses: [
        { name: "优惠服务" },
        { name: "学习教育" },
        { name: "便捷咨询" },
        { name: "其他服务" }
      ],
      isClass: 0,
      banners: [
        {
          imgUrl: require("@/assets/index/partyAllience/live/dp-sy-lm22.png"),
          index: 0
        },
        {
          imgUrl: require("@/assets/index/partyAllience/live/dp-sy-lm23.png"),
          index: 1
        },
        {
          imgUrl: require("@/assets/index/partyAllience/live/dp-sy-lm25.png"),
          index: 2
        },
        {
          imgUrl: require("@/assets/index/partyAllience/live/dp-sy-lm24.png"),
          index: 3
        }
      ],
      msgs: []
    };
  },
  methods: {
    active(index, name) {
      this.isClass = index;
      this.getMsg(name);
    },
    getMsg(name) {
      this.axios
        .get(
          `/api/Main/ActivityLists?typename=财富中心综合党委&name=${name}`
        )
        .then(e => {
          switch (e.data.code) {
            case 0:
              this.msgs = e.data.msg;
              break;

            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // geDetail(id){
    //    this.$router.push({
    //     path: "publicDetail",
    //     query: { title: "新闻动态", id: id, dbnum: 1 }
    //   });
    // }
  },
  mounted(){
    this.getMsg('优惠服务')
  }
};
</script>

<style lang="scss" scoped>
.allience {
  .learn-to-teach,
  .convenient-consulting,
  .other-serve,
  .preferentital-service {
    .preferentital-service-template {
      p {
        &:nth-child(1) {
          font-weight: bold;
          line-height: 2;
        }
        &:nth-child(2) {
          line-height: 1.5;
          color: #999999;
        }
      }
      margin-top: 0.3rem;
    }
    width: 94%;
    margin: 0.3rem auto;
  }
  .banner {
    img {
      width: 94%;
    }
    text-align: center;
    margin-top: 0.2rem;
  }
  .choose-state {
    span {
      width: 25%;
    }
    .choose {
      font-weight: bold;
      color: #ffa000;
    }
    align-items: center;
    color: #999999;
    display: flex;
    text-align: center;
    width: 100%;
    overflow-x: scroll;
    background: #fff;
    line-height: 3;
  }
  font-size: 0.3rem;
  padding-top: 1rem;
}
</style>